define('shared/remote/payment/adyen/constructPayWithTokenPayload',[
    'Promise',
    'shared/my/identity',
    'shared/my/cmus',
    'shared/page/market',
    'shared/page/partner'
], function (
    Promise,
    getIdentity,
    getCMus,
    getMarket,
    getPartner
) {

    return function (offers) {
        return Promise.all([
            getIdentity(),
            getCMus(),
            getMarket(),
            getPartner()
        ])
            .then(function(values){
                var memberId = values[0];
                var cmus = values[1];
                var market = values[2];
                var partner = values[3];
                return {
                    'cmus': cmus,
                    'memberId': memberId,
                    'country': market,
                    'partner': partner,
                    'offerIds': offers,
                    'extraInfo': {
                        'adyenOrigin': window.location.origin,
                        'adyenSdkVersion': '1.9.2',
                        'returnUrl': window.location.origin + window.location.pathname
                    }
                };
            });
    };
});

